import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as forge from 'node-forge';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/utils/utils';
import { MessageService } from 'primeng/api';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { AprovadorService } from 'src/app/services/aprovador.service';
import { LoginService } from 'src/app/services/login.service';
import { NewAprovadorDTO } from '../../../models/newAprovadorDTO.model';
import { sha256 } from 'js-sha256';

@Component({
  selector: 'app-gerar-nova-senha-aprovador',
  templateUrl: './gerar-nova-senha-aprovador.component.html',
  styleUrls: ['./gerar-nova-senha-aprovador.component.css']
})
export class GerarNovaSenhaAprovadorComponent implements OnInit {

  formGroup: FormGroup;
  isSubmit: boolean = false;
  labelAuth1: string = "Autenticação 1";
  labelAuth2: string = "Autenticação 2";
  aprovador: any = { id: null, idCandidatura: null};

  constructor(
    protected formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public utils: Utils,
    public routes: ActivatedRoute,
    public route: Router,
    protected eleicaoService: EleicaoService,
    protected candidaturaService: CandidaturaService,
    private aprovadorService: AprovadorService,
    private loginService: LoginService,
    protected messageService: MessageService
  ) { }

  async ngOnInit() {
    this.formGroup = new FormGroup({
      login: new FormControl(),
      senha: new FormControl(),
      confirmaSenha: new FormControl(),
      auth1: new FormControl(),
      auth2: new FormControl(),
    })
    let parametrosRota = this.routes.snapshot.params;
    let eleicaoRota = parametrosRota.rotaEleicao;
    

    //let eleicaoRota = this.routes.snapshot.params.rotaEleicao;
    this.getAuths(eleicaoRota);
    const token = "Bearer " + this.routes.snapshot.params.token;
    try {
      await this.validaToken(token);
    } catch (error) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: error });
    }
    
    this.formGroup = this.formBuilder.group({
      login: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      senha: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      confirmaSenha: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      auth1: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      auth2: ['', [Validators.required, this.utils.noWhitespaceValidator]],
    }, {
      validators: this.confirmedValidator
    });

    this.spinner.hide();
  }

  public getAuths(eleicaoRota: string) {
    this.eleicaoService.getEleicaoByRota(eleicaoRota).then((resp: any)=>{
      if (resp.labelAuth1 != null) this.labelAuth1 = resp.labelAuth1;
      if (resp.labelAuth2 != null) this.labelAuth2 = resp.labelAuth2;
    }).catch(err=>{
      this.messageService.add({ key: 'toast', severity: 'error', summary: "Atenção", detail: "Eleição não se encontra disponível para login." });
    });
  }

  private validaToken(token) {
    this.loginService.getRedefinirSenhaAprovador(token).then( resp => {
      this.aprovador = resp;
    }).catch(error => {
      this.route.navigate([this.routes.snapshot.params.rotaEleicao], { queryParams: { role: 'aprovador' } });
    });
  }

  public async onSubmit(){
    this.isSubmit = true;
    if (!this.formGroup.valid) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }
    const token = "Bearer " + this.routes.snapshot.params.token;
    //await this.validaToken(token);
    if (this.aprovador && this.aprovador.id) {
      let novoAprovador: NewAprovadorDTO = new NewAprovadorDTO();
      novoAprovador.login = sha256.update(this.formGroup.get('login').value).hex();
      novoAprovador.senha = sha256.update(this.formGroup.get('senha').value).hex();
      novoAprovador.auth1 = sha256.update(this.formGroup.get('auth1').value).hex();
      novoAprovador.auth2 = sha256.update(this.formGroup.get('auth2').value).hex();
      novoAprovador.candidatura = {id: this.aprovador.idCandidatura};
      
      this.updateAprovador(novoAprovador, this.aprovador.id, token);
    } else {
      this.formGroup.get("senha").setValue('');
      this.formGroup.get("confirmaSenha").setValue('');
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Algo deu errado!" });
    }
  }

  private updateAprovador(aprovador, idAprovador, token) {
    this.aprovadorService.updateAprovador(aprovador, idAprovador, token).then(() => {
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Senha atualizada com sucesso!' });
      setTimeout(() => {
        this.route.navigate([this.routes.snapshot.params.rotaEleicao], { queryParams: { role: 'aprovador' } });
      }, 2500);
    }, error => {
      console.log("updateAprovador: ", error);
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: "Dados de autenticação incorretos, tente novamente." });
      this.formGroup.reset();
    });
  }

  private confirmedValidator(control: FormControl){
    return control.get("senha").value !== control.get("confirmaSenha").value ? { 'notMatch': true } : null;
  }
}
